import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "home",
    component: () => import("../views/HomeView.vue"),
  },
  {
    path: "/philosophy",
    name: "philosophy",
    component: () => import("../views/PhilosophyView.vue"),
  },
  {
    path: "/feature",
    name: "feature",
    component: () => import("../views/FeatureView.vue"),
  },
  {
    path: "/result",
    name: "result",
    component: () => import("../views/ResultView.vue"),
  },
  {
    path: "/contact",
    name: "contact",
    component: () => import("../views/ContactView.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

export default router;
